import {Component, Input, OnInit} from '@angular/core';
import {DeckType} from '../../shared/card-deck';
import {MatSidenav} from '@angular/material/sidenav';
import {Observable} from 'rxjs';
import {CardPattern} from '../../shared/card-pattern';
import {CardStoreService} from '../../shared/card-store.service';
import {EditorService} from '../shared/editor.service';
import {CardWebService} from '../../shared/card-web.service';
import {ElementLock, ElementLockType} from '../shared/ElementLock';
import {CommunityConnectorService} from '../../shared/community-connector.service';


@Component({
  selector: 'em-pattern-card',
  templateUrl: './pattern-card.component.html',
  styleUrls: ['./pattern-card.component.css']
})
export class PatternCardComponent implements OnInit {
  @Input() cardDeckId: number;
  @Input() cardPatternId: number;
  @Input() cardDeckType: DeckType;
  @Input() rightSidenav: MatSidenav;
  @Input() showSelectToggle: boolean;
  @Input() elementLock: ElementLock;
  @Input() shareOption: string;

  cardPattern$: Observable<CardPattern>;
  buttoncolor;
  controlLoopImageName: string;

  constructor(
    private cs: CardStoreService,
    private es: EditorService,
    private cw: CardWebService,
    private ccs: CommunityConnectorService
  ) {
  }
    protected readonly ElementLockType = ElementLockType;

  ngOnInit(): void {
    this.cardPattern$ = this.cs.getPatternCardWithCell(this.cardDeckId, this.cardPatternId, this.cardDeckType);
    this.fetchControlLoopImageName();
    this.buttoncolor = '';
  }

  public openSideMenu(preference: ('left'|'right'|'bottom')) {
    this.cardPattern$.subscribe(pattern => {
      this.es.setConnectionParams({cardPattern: pattern, cardId: pattern.id});
    });
    if (this.rightSidenav !== undefined) {
      this.rightSidenav.toggle();
      this.cw.setConnectionPreference(preference);
    }
  }

  fetchControlLoopImageName() {
    if (this.cardDeckType === DeckType.pattern) {
      const elementAttributionObservable = this.cs.getControlLoopAttribution(this.cardDeckId, this.cardPatternId);
      elementAttributionObservable.subscribe( elementAttribution => {
        let controlLoopName = '';
        for (const category of elementAttribution.categories){
          for (const item of category.items) {
            if (item.elementId === this.cardPatternId) {
              switch (category.title) {
                case 'Auftrag':
                  controlLoopName = 'regelkreis_auftrag.png';
                  break;
                case 'Aktion':
                  controlLoopName = 'regelkreis_aktion.png';
                  break;
                case 'Welt':
                  controlLoopName = 'regelkreis_welt.png';
                  break;
                case 'Reaktion':
                  controlLoopName = 'regelkreis_reaktion.png';
                  break;
                default:
              }
            }
          }
        }
        if (controlLoopName !== '') {
          this.controlLoopImageName = controlLoopName;
        }else{
          console.error('No ControlLoopAttribution found for element ' + this.cardPatternId + ' and deckType ' + this.cardDeckType);
        }
      });
    }
  }

  isFromDeckTypePattern() {
    return this.cardDeckType === DeckType.pattern;
  }

  getAvatarTemplateUrl(avatarTemplate: string) {
    return this.ccs.getAvatarTemplateUrl(avatarTemplate);
  }

  canAccessLinkMenu() {
    if (this.shareOption === undefined) {
      return true;
    }else {
        return this.shareOption === 'edit';
    }
  }
}
